import { Component, Input, OnInit } from '@angular/core';
import { ContactDataDto } from '@bo-client/shared/models/contactDataDto';

@Component({
  selector: 'app-filiation-data-summary',
  templateUrl: './filiation-data-summary.component.html',
  styleUrls: ['../../../../../../shared/summaries/css-summary.component.scss']
})
export class FiliationDataSummaryComponent implements OnInit {
  @Input() contactData: ContactDataDto;
  @Input() title: string;

  constructor() {}

  ngOnInit(): void {}
}
